import { render, staticRenderFns } from "./c_activities.vue?vue&type=template&id=5d616811&scoped=true"
import script from "./c_activities.vue?vue&type=script&lang=js"
export * from "./c_activities.vue?vue&type=script&lang=js"
import style0 from "./c_activities.vue?vue&type=style&index=0&id=5d616811&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d616811",
  null
  
)

export default component.exports